import { UIComponentCSSStyle, UIComponentCSSStyleImpl } from '../../../../toolkit/uicomponentcss';
import { Fonts } from '../../../../../utils/resources/fonts';
import { Colors } from '../../../../../utils/resources/colors';
export interface ToneOptionCardCSSStyle extends UIComponentCSSStyle
{   
    getIconDivCSSStyle():object;
    getTitleLabelCSSStyle():object;
}

export class ToneOptionCardCSSStyleImpl extends UIComponentCSSStyleImpl implements ToneOptionCardCSSStyle
{
    getWrapperCSSStyle():object
    {
        return{
            width:'85px',
            height:'85px',
            backgroundColor:this.getResources().getColor(Colors.color_5),
            border:'1px solid '+this.getResources().getColor(Colors.color_26),
            cursor: "pointer",
            boxShadow: '0 -4px 7px 1px rgba(0,0,0,0.04)',
            
  
        };
    }
    
    getIconDivCSSStyle():object{
        return{
            margin:'20px 20px 5px 20px',
            cursor: "pointer",
        };
    }

    getTitleLabelCSSStyle():object
    {
        return{
            align:'center',
            width:'90%',
            height:'17px',
            fontSize:this.getResources().getFont(Fonts.h5),
            lineHeight:'17px'
        };
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/toneoption/toneoptioncard/toneoptioncardcss.tsx